import React, { useEffect, useState } from "react";
import { Button, InputAdornment, TextField } from "@material-ui/core";
import building from "./assets/course-building.webp";
import people from "./assets/feature-people.svg";
import video from "./assets/feature-video.svg";
import star from "./assets/feature-star.svg";
import calendar from "./assets/feature-calendar.svg";
import contactUser from "./assets/contact-user.svg";
import contactPhoneIcon from "./assets/contact-phone.svg";
import send from "./assets/send.svg";

const topics = [
  "חוק עידוד השקעות הון",
  "פירוק חברות והעברת נכסים לבעלי מניות",
  "הפקעות, איחוד חלוקה, מתנות וחלוקת עיזבון, פרצלציה לא רצונית, הענקה למוסדות",
  "אופציה במקרקעין - ייחודית ורגילה",
  "היטלי השבחה - כללי והתחדשות עירונית",
  "הוראת שעה לפי חוק הרווחים הכלואים ועוד ועוד..."
];

function desktopScale() {
  // Figma uses a large working canvas; display it as a compact desktop modal.
  // Fit the complete form on ordinary laptops, retaining scrolling at high zoom.
  return Math.min(600 / 980, Math.max(0.2, (window.innerWidth - 48) / 980), Math.max(0.5, (window.innerHeight - 48) / 1138));
}

export function useCoursePopupScale() {
  const [scale, setScale] = useState(desktopScale);
  useEffect(() => {
    const resize = () => setScale(desktopScale());
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);
  return scale;
}

function Feature({ icon, className = "", children }) {
  return <div className="course-campaign-feature">
    <span className={"course-campaign-feature-circle " + className}><img src={icon} alt="" aria-hidden="true" /></span>
    <div className="course-campaign-feature-label">{children}</div>
  </div>;
}

export default function CourseCampaignContent({ success, busy, uncertain, contactName, contactPhone,
  fieldErrors, error, nameInput, onNameChange, onPhoneChange, onPhoneBlur, onClose }) {
  return <>
    <section className="course-campaign-hero" aria-label="פרטי הקורס">
      <img className="course-campaign-building" src={building} alt="" aria-hidden="true" />
      <div className="course-campaign-headline" dir="rtl">
        <p className="course-campaign-eyebrow"><span aria-hidden="true" />עולים רמה</p>
        <h2 id="course-campaign-title"><span>מיסוי מקרקעין</span><strong>למתקדמים</strong></h2>
        <span className="course-campaign-title-spacer" aria-hidden="true" />
        <section className="course-campaign-topics" aria-labelledby="course-campaign-topics-title">
          <h3 id="course-campaign-topics-title">בין נושאי הקורס:</h3>
          <ul>{topics.map((topic) => <li key={topic}><span>{topic}</span></li>)}</ul>
        </section>
      </div>
    </section>
    <section className="course-campaign-features" aria-label="מידע נוסף על הקורס">
      <Feature icon={people}><p>מרצים בכירים</p><p>ומובילים בתחום</p></Feature>
      <span className="course-campaign-feature-divider" aria-hidden="true" />
      <Feature icon={video}><p>מתקיים בזום</p></Feature>
      <span className="course-campaign-feature-divider" aria-hidden="true" />
      <Feature icon={star}><p>10 מפגשים</p><p dir="auto">+ 2 מפגשי בונוס</p></Feature>
      <span className="course-campaign-feature-divider" aria-hidden="true" />
      <Feature icon={calendar}><p><time dateTime="2026-11-01" dir="ltr">01.11.26</time></p><p>מתחילים</p></Feature>
    </section>
    <section className="course-campaign-form-section" aria-label="השארת פרטים">
      {success ? <>
        <div className="course-campaign-form-heading course-campaign-success" id="course-campaign-description" role="status">
          <h3>הפנייה נשלחה בהצלחה!</h3>
          <p>תודה על ההתעניינות בקורס. נחזור אליכם עם כל המידע.</p>
          {error && <p role="alert" className="course-campaign-error">{error}</p>}
        </div>
        <Button className="course-campaign-submit" type="button" onClick={onClose}>סגירה</Button>
      </> : <>
        <div className="course-campaign-form-heading">
          <h3>מספר המקומות מוגבל!</h3>
          <p>מלאו פרטים ונחזור אליכם עם כל המידע</p>
        </div>
        <div className="course-campaign-fields">
          <TextField id="course-contact-name" name="contactName" label="שם מלא" placeholder="שם מלא" inputRef={nameInput}
            value={contactName} onChange={onNameChange} required fullWidth variant="outlined" disabled={busy}
            error={Boolean(fieldErrors.contactName)} helperText={fieldErrors.contactName} autoComplete="name"
            InputLabelProps={{ className: "course-campaign-sr-only", shrink: true }}
            InputProps={{ notched: false, startAdornment: <InputAdornment position="start"><img src={contactUser} alt="" aria-hidden="true" /></InputAdornment> }}
            inputProps={{ maxLength: 100, "aria-describedby": fieldErrors.contactName ? "course-contact-name-helper-text" : "course-campaign-description" }} />
          <TextField id="course-contact-phone" name="contactPhone" label="טלפון" placeholder="טלפון"
            value={contactPhone} onChange={onPhoneChange} onBlur={onPhoneBlur} required fullWidth variant="outlined" disabled={busy}
            error={Boolean(fieldErrors.contactPhone)} helperText={fieldErrors.contactPhone} type="tel" autoComplete="tel"
            InputLabelProps={{ className: "course-campaign-sr-only", shrink: true }}
            InputProps={{ notched: false, startAdornment: <InputAdornment position="start"><img src={contactPhoneIcon} alt="" aria-hidden="true" /></InputAdornment> }}
            inputProps={{ maxLength: 40, dir: "ltr", inputMode: "numeric", "aria-describedby": "course-contact-phone-hint " + (fieldErrors.contactPhone ? "course-contact-phone-helper-text" : "course-campaign-description") }} />
          <span id="course-contact-phone-hint" className="course-campaign-sr-only">מספר נייד או טלפון קווי, כולל קידומת.</span>
        </div>
        {error && <p role="alert" className="course-campaign-error">{error}</p>}
        <Button className="course-campaign-submit" type="submit" disabled={busy || uncertain}>
          <span dir="rtl">{busy ? "שולח…" : "שלח"}</span><img src={send} alt="" aria-hidden="true" />
        </Button>
        <div className="course-campaign-footer-actions">
          <Button type="button" className="course-campaign-dismiss" onClick={onClose} disabled={busy}>אולי בפעם אחרת</Button>
        </div>
        <p id="course-campaign-description" className="course-campaign-referral-note">ניתן להשאיר גם פרטי אדם אחר, בהסכמתו לקבלת פנייה בנוגע לקורס.</p>
      </>}
    </section>
  </>;
}
